<div class="card-body">
    
    <div *ngIf="loading" class="d-flex justify-content-center">
        <H5 class="text-warning my-5">Chargement en cours...</H5>
    </div>
    <div *ngIf="!loading">
            <h5 class="text-danger" *ngIf="!!creditSafeErrorMessage">{{creditSafeErrorMessage}}</h5>
            <div class="row" *ngIf="creditSafeDatas">
                <div class="col-5">
                    <table class="table table-sm table-bordered mt-3" style="width:100%;">
                        <tbody>
                            <tr>
                                <td><label class="control-label">Raison sociale</label></td>
                                <td>{{creditSafeDatas.RaisonSociale}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Nom commercial</label></td>
                                <td>{{creditSafeDatas.NomCommercial}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">SIRET</label></td>
                                <td>{{creditSafeDatas.Siret}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Capital Social</label></td>
                                <td>{{creditSafeDatas.CapitalSocial}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">N° TVA</label></td>
                                <td>{{creditSafeDatas.TvaIntra}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">N° RCS</label></td>
                                <td>{{creditSafeDatas.NumRCS}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Date de création</label></td>
                                <td>{{creditSafeDatas.DateCreation | date:'dd/MM/yyyy'}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Statut de l'établissement</label></td>
                                <td>{{creditSafeDatas.StatutEtablissement}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Jugements</label></td>
                                <td>{{creditSafeDatas.Jugements}}</td>
                            </tr>
                            <tr>
                                <td><label class="control-label">Nombre estimé d'employés</label></td>
                                <td>{{creditSafeDatas.NbEmployes}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-6 offset-1">
                    <div class="d-flex flex-column mt-3 align-items-center ">
                        <span class="badge px-5" [ngClass]="scoreClass(creditSafeDatas)" [title]="creditSafeDatas.ScoreLetterDescription" data-toggle="tooltip" style="color: white;">
                            <H2>{{creditSafeDatas.ScoreLetter}}</H2>
                            <H6>{{getScoreLib(creditSafeDatas)}}</H6>
                        </span>
                        <table class="table table-bordered table-sm mt-3" style="width:100%;">
                            <thead>
                                <tr class="text-center">
                                    <th>Période</th>
                                    <th>Durée<small *ngIf="financialStatements.length>0"> ({{financialStatements[0].DureeUnit}})</small></th>
                                    <th>Chiffre d'affaire</th>
                                    <th>Résultat Net</th>
                                    <th>Devise</th>
                                    <th>Consolidée</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let line of financialStatements">
                                    <td class="text-center">{{line.Periode | date:'dd/MM/yyyy'}}</td>
                                    <td class="text-center">{{line.Duree}}</td>
                                    <td *ngIf="line.CA" class="text-right text-currency">{{line.CA | number: '1.2-2':'fr'}}</td>
                                    <td *ngIf="line.CA" class="text-right text-currency">{{line.ResultatNet | number: '1.2-2'}}</td>
                                    <td *ngIf="line.CA" class="text-center">{{line.Devise}}</td>
                                    <td *ngIf="line.CA" class="text-center">{{ConsolideLib(line)}}</td>
                                    <td *ngIf="!line.CA" colspan="4" class="text-center">{{line.reasonForNonCapture ||'NC'}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex">
                            <button type="button" class="btn btn-xs btn-primary" (click)="refreshDatas()">
                                <i class="fas fa-sync"></i>
                            </button>
                            <div class="ml-3">
                                Dernière mise à jour : {{creditSafeDatas.MajDat | date: 'dd/MM/yyyy HH:mm:ss'}} 
                            </div>                        
                        </div>
                        <button type="button" class="btn btn-primary mt-3" (click)="getCreditSafePdf(creditSafeDatas)">
                            Visualiser l'analyse complète
                        </button>
                    </div>
                </div>
            </div>

        <div *ngIf="!creditSafeDatas" sclass="d-flex">
            <button type="button" class="btn btn-xs btn-primary" (click)="refreshDatas()">
                <i class="fas fa-sync"></i>
            </button>
        </div>
    </div>
</div>